export default "__VITE_ASSET__Doju2EQe__"